import Field from "@components/global/new/Field/Field";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { useIntl } from "react-intl";
import styles from "./ShowProxySetting.module.scss";
import { ALGO_PORTS } from "../../../../config";
import { ALGOS_E } from "@constants/Algos";
import { IStoredSetting } from "@store/me/actionTypes";
import { useProxySettingControl } from "./useShowProxySetting";
import { ICurrentSetting, IPoolCreds } from "@services/getSettings";
import { Input } from "@components/global/new/Input/Input";

export interface IShowProxySettingProps extends CommonModalPropsI {
  // readonly setting: AddPoolParams;
  // readonly hash: ALGOS_E;
  readonly id: string;
  readonly miner_id: string;
  readonly settings: IPoolCreds[];
}

function ShowProxySetting(props: IShowProxySettingProps) {
  if (!props.settings) return null;
  const { formatMessage } = useIntl();
  const control = useProxySettingControl(props);

  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        <h4>
          {formatMessage({ id: "modal.pool.title_proxy" })} {props.miner_id}
        </h4>
      </div>
      <div className={styles.content}>
        {props.settings.map((s, i) => {
          return (
            <div className={styles.option_wrapper} key={i}>
              <span>{formatMessage({ id: `settings.option.${i + 1}` })}</span>
              <div className={styles.option}>
                <Input
                  label={formatMessage({ id: "settings.option.address" })}
                  type="text"
                  value={s.address}
                  copyButton
                  readOnly
                />
                {/* <Address
              pool={checkPool(0)}
              port={findPort(props.hash as keyof typeof ALGO_PORTS)}
              portKey={0}
              postfix={postfix}
            /> */}
                <Input
                  label={formatMessage({ id: "settings.option.login" })}
                  type="text"
                  value={s.login}
                  copyButton
                  readOnly
                />
                <Input
                  label={formatMessage({ id: "settings.option.password" })}
                  type="text"
                  value={s.password}
                  copyButton
                  readOnly
                />
              </div>
            </div>
          );
        })}
        {/* <div className={styles.option_wrapper}>
          <span>{formatMessage({ id: `settings.option.2` })}</span>
          <div className={styles.option}>
            <Address
              pool={checkPool(1)}
              port={findPort(props.hash as keyof typeof ALGO_PORTS)}
              portKey={1}
              postfix={postfix}
            />
            <Field
              name={formatMessage({ id: "settings.option.login" })}
              type='text'
              defaultValue={`${props.id}.${props.miner_id}`}
              copy
              disabled
              readOnly
            />
            <Field
              name={formatMessage({ id: "settings.option.password" })}
              type='text'
              defaultValue={"x"}
              copy
              disabled
              readOnly
            />
          </div>
        </div>
        <div className={styles.option_wrapper}>
          <span>{formatMessage({ id: `settings.option.3` })}</span>
          <div className={styles.option}>
            <Address
              pool={checkPool(2)}
              port={findPort(props.hash as keyof typeof ALGO_PORTS)}
              portKey={2}
              postfix={postfix}
            />
            <Field
              name={formatMessage({ id: "settings.option.login" })}
              type='text'
              defaultValue={`${props.id}.${props.miner_id}`}
              copy
              disabled
              readOnly
            />
            <Field
              name={formatMessage({ id: "settings.option.password" })}
              type='text'
              defaultValue={"x"}
              copy
              disabled
              readOnly
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}
export default WithModal(MODALS_ENUM.SHOW_PROXY_SETTING, ShowProxySetting);
